export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-8b-4f21319eb4b913776ddf3554b9c05445.webp";